import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '@/router'
import firebase from '@firebase/app'
import '@firebase/messaging'
import moment from 'moment-timezone'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    accessToken: localStorage.getItem('access_token'),
    refreshToken: localStorage.getItem('refresh_token'),
    accountData: localStorage.getItem('account_data'),
    chosenModule: localStorage.getItem('chosen_module'),
    isOffline: false,
    firebaseMessaging: null
  },
  mutations: {
    changeChosenModule (state, chosenModule) {
      localStorage.setItem('chosen_module', chosenModule)
      Vue.set(state, 'chosenModule', chosenModule)
    },
    login (state, tokens) {
      state.accessToken = tokens.access_token
      state.refreshToken = tokens.refresh_token
      if (!tokens.account_data !== null) {
        state.accountData = tokens.account_data
      }
    },
    logout (state) {
      state.toggled = false
      state.accessToken = null
      state.refreshToken = null
      state.accountData = null
    },
    checkIsOffline (state, status) {
      state.isOffline = status
    }
  },
  actions: {
    doChooseModule ({ commit }, chosenModule) {
      commit('changeChosenModule', chosenModule)
    },
    login ({ state, commit, dispatch, rootState }, credentials) {
      return axios.post(window.AppConfig.baseApiUrl + 'oauth', {
        username: credentials.username,
        password: credentials.password,
        grant_type: 'password',
        client_id: window.AppConfig.clientId,
        client_secret: window.AppConfig.clientSecret
      })
        .then(response => {
          const a = response.data
          return dispatch('getAccountData', a.access_token).then((response) => {
            return dispatch('saveTokens', {tokens: a, accountData: JSON.stringify(response), isLocalLogin: false})
          }).catch(error => {
            return Promise.reject(error)
          })
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    getAccountData ({ state, commit, dispatch }, accessToken) {
      return axios.get(window.AppConfig.baseApiUrl + 'api/me', {headers: { Authorization: 'Bearer ' + accessToken }})
        .then(response => {
          return response.data
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    updateAccountDataBillingConfigs ({ dispatch, state }) {
      return axios.get(window.AppConfig.apiUrl + 'billing-receipt?limit=2&ascending=1&order=order')
        .then(response => {
          return dispatch('updateAccountData', {key: 'billingConfigs', value: response.data._embedded.billingReceipt})
        })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    refreshToken ({ state, commit, rootState }) {
      return axios.post(window.AppConfig.baseApiUrl + 'oauth', {
        grant_type: 'refresh_token',
        client_id: window.AppConfig.clientId,
        client_secret: window.AppConfig.clientSecret,
        refresh_token: state.refreshToken
      }).then(response => {
        return response.data
      })
        .catch(error => {
          return Promise.reject(error)
        })
    },
    localLogin () {
      return {
        data: {
          access_token: localStorage.getItem('access_token'),
          refresh_token: localStorage.getItem('refresh_token')
        }
      }
    },
    logout ({ commit, state, dispatch }) {
      dispatch('clearFirebase')
      localStorage.removeItem('account_data')
      return axios.post(window.AppConfig.baseApiUrl + 'oauth/revoke', {
        token_type_hint: 'access_token',
        token: state.accessToken
      }).then(() => {
        localStorage.removeItem('access_token')
        localStorage.removeItem('refresh_token')
        commit('logout')
      })
        .catch(() => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('refresh_token')
          commit('logout')
        })
    },
    initFirebase ({
      state
    }) {
      if ('serviceWorker' in navigator) {
        if (!firebase.apps.length) {
          firebase.initializeApp(window.AppConfig.fbase.initializeConfig)
          state.firebaseMessaging = firebase.messaging()
          state.firebaseMessaging.usePublicVapidKey(window.AppConfig.fbase.vapidKey)

          navigator.serviceWorker.register('./static/js/firebase-messaging-sw.js?baseUrl=' + window.location.origin).then((registration) => {
            state.firebaseMessaging.useServiceWorker(registration)
            state.firebaseMessaging.requestPermission().then(() => {
              state.firebaseMessaging.getToken().then((currentToken) => {
                if (currentToken) {
                  return axios.post(window.AppConfig.apiUrl + 'mobilestate', {
                    firebaseId: currentToken
                  }).then(() => {
                  }).catch(() => {
                    window.consoleLog('cannot save notif token')
                  })
                }
              })
            }).catch(() => {
              alert('Please Allow Notification Permission')
            })
          })
        } else {
          state.firebaseMessaging.requestPermission().then(() => {
            state.firebaseMessaging.getToken().then((currentToken) => {
              if (currentToken) {
                return axios.post(window.AppConfig.apiUrl + 'mobilestate', {
                  firebaseId: currentToken
                }).then(() => {
                }).catch(() => {
                  window.consoleLog('cannot save notif token')
                })
              }
            })
          })
        }
        state.firebaseMessaging.onTokenRefresh(() => {
          state.firebaseMessaging.getToken().then(refreshedToken => {
            return axios.post(window.AppConfig.apiUrl + 'mobilestate', {
              firebaseId: refreshedToken
            }).then(() => {
            }).catch(() => {
              window.consoleLog('cannot save notif token')
            })
          })
        })
      } else {
        // alert('This browser not supported Notification')
      }
    },
    clearFirebase ({
      state
    }) {
      if ('serviceWorker' in navigator && state.firebaseMessaging !== null) {
        state.firebaseMessaging.getToken().then((currentToken) => {
          if (currentToken) {
            state.firebaseMessaging.deleteToken(currentToken)
          }
        })
      }
    },
    updateAccountData ({ state }, params) {
      let accountData = JSON.parse(state.accountData)
      accountData[params.key] = params.value
      localStorage.setItem('account_data', JSON.stringify(accountData))
      state.accountData = JSON.stringify(accountData)
    },
    saveTokens ({ state, commit, getters, dispatch }, params) {
      let a = params.tokens.access_token
      let b = params.tokens.refresh_token
      const c = params.accountData === null ? state.accountData : params.accountData
      if (!params.isLocalLogin) {
        localStorage.setItem('access_token', a)
        localStorage.setItem('refresh_token', b)
        localStorage.setItem('account_data', c)
      }
      commit('login', {
        access_token: a,
        refresh_token: b,
        account_data: c
      })
      // set default timezone based on Account Data
      moment.tz.setDefault(getters.accountData.timezone)
      axios.interceptors.request.use(config => {
        dispatch('setIsOffline', false)
        if (state.accessToken !== null) {
          config.headers.Authorization = 'Bearer ' + state.accessToken
        }
        return config
      })
      dispatch('initFirebase')
      if (!params.isLocalLogin) {
        dispatch('updateAccountDataBillingConfigs')
      }
      return axios.interceptors.response.use(undefined, function (err) {
        if (err.response === undefined) {
          if (err.message === 'Network Error') dispatch('setIsOffline', true)
        } else {
          dispatch('setIsOffline', false)
          if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
            return new Promise(function (resolve, reject) {
              return dispatch('refreshToken').then(response => {
                localStorage.setItem('access_token', response.access_token)
                localStorage.setItem('refresh_token', response.refresh_token)
                commit('login', {
                  access_token: response.access_token,
                  refresh_token: response.refresh_token,
                  account_data: state.accountData
                })
                err.config.__isRetryRequest = true
                // err.config.headers.Authorization = 'Bearer ' + response.access_token
                axios(err.config).then(resolve, reject)
              }).catch(function (error) {
                return Promise.reject(error)
              })
            })
          } else if (err.response.status === 400) {
            router.push('')
          } else {
            return Promise.reject(err)
          }
        }
      })
    },
    setIsOffline: ({commit}, status) => commit('checkIsOffline', status),
    errorMessage ({commit}, error) {
      window.consoleLog(error)
      let messages = 'Sorry for the inconvenience.<br/>'
      if (typeof error.response !== 'undefined') {
        let validationMessages = null
        let subValidationMessages = null
        if (error.response.data.validation_messages !== undefined) {
          validationMessages = error.response.data.validation_messages
          if (validationMessages !== undefined) {
            if (Object.keys(validationMessages).length) {
              messages += '<ul>'
              for (let i = 0; i < Object.keys(validationMessages).length; i++) {
                subValidationMessages = validationMessages[Object.keys(validationMessages)[i]]
                for (let j = 0; j < Object.keys(subValidationMessages).length; j++) {
                  messages +=
                    '<li>' +
                      subValidationMessages[Object.keys(subValidationMessages)[j]] +
                    '</li>'
                }
              }
              messages += '</ul>'
            }
          }
        } else if (error.response.data.message !== undefined) {
          messages += error.response.data.message + '. '
        } else if (error.response.data.detail !== undefined) {
          messages += error.response.data.detail + '. '
        } else {
          messages += error.response.data.status + '. ' + window.ConvertSnakeCaseMesssage(error.response.data.title)
        }
      } else if (error.message === 'Network Error') {
        messages = '<b>You are not connected to internet</b>. Please check your connection'
      } else {
        messages += 'Please call Administrator to get advance information'
      }
      return messages
    }
  },
  getters: {
    accessTokenHeader: state => {
      return 'Bearer ' + state.accessToken
    },
    accessTokens: state => {
      return {
        access_token: state.accessToken,
        refresh_token: state.refreshToken
      }
    },
    accountData: state => {
      return JSON.parse(state.accountData)
    },
    getChosenModule: state => {
      return state.chosenModule
    },
    isLoggedIn: state => {
      return state.accessToken
    },
    isOffline: state => state.isOffline
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js